import React from 'react';
import { useSelector } from 'shared/node_modules/react-redux';
import UnityLinkAccount from './UnityLinkAccount';
import DefaultLinkAccount from './DefaultLinkAccount';

const LinkAccount = () => {
  const playerPropertyLoyaltyCardType = useSelector(state => state.properties?.data?.playerPropertyLoyaltyCardType);
  const LinkAccount =
    {
      default: DefaultLinkAccount,
      unity: UnityLinkAccount,
      grandrewards: UnityLinkAccount,
      sweetwaterrewards: UnityLinkAccount,
    }[playerPropertyLoyaltyCardType] || DefaultLinkAccount;

  return <LinkAccount />;
};

LinkAccount.AsModalProps = {
  dialogClassName: 'gtp-modal-link-account',
};

export default LinkAccount;

